export default "__VITE_ASSET___jNJEJUn__"